// F-U (2026-10-05): the zone / exhibit forms' "Back" (header + next to
// Update) returns to the list as the user left it, after confirming when
// there are unsaved edits.

import { useNavigate } from "react-router-dom";
import { listReturnUrl, type ListKind } from "./listReturn";

export const DISCARD_PROMPT = "Discard unsaved changes?";

/** Create mode has no saved record to diff against — anything typed counts. */
export function hasTypedContent(form: object): boolean {
  return Object.values(form).some(
    (v) => typeof v === "string" && v.trim() !== "",
  );
}

export function useBackToList(kind: ListKind, hasUnsaved: boolean): () => void {
  const navigate = useNavigate();
  return () => {
    if (hasUnsaved && !window.confirm(DISCARD_PROMPT)) return;
    navigate(listReturnUrl(kind));
  };
}
